/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2019-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import _ from 'lodash';

/**
 * Some shared functions
 */
class Core {
    // return true if the value is [], {}, "", null, undefined
    empty(val) {
        return _.isEmpty(val) && !_.isNumber(val) && !_.isDate(val);
    }

    // get the id from a url
    getId(url, pos = 1) {
        // href looks like http://192.168.240.239:8080/api/tenants/1
        const res = (url || '').split('/');
        // get the tenant id from the url
        return res.length > 2 ? res[res.length - 1] : 0;
    }

    // truncate the string and given length (cut) adding ... if truncate
    truncate(string, cut) {
        if (string !== undefined && string.length > 15) {
            let newString = string.slice(0, cut) + '...';
            return newString;
        } else {
            return string;
        }
    }

    padding(string, len) {
        if (string !== undefined) {
            let newString = (string + "    ").slice(0, len);
            return newString;
        }
    }

    /**
     * Saves value to the browser's Local Storage
     * @param key The key against which the value will be stored.
     * @param val The value/object to be stored
     * @param isObject Objects are stored in JSON, set to false if string.
     */
    saveLocal(key, val, isObject = true) {
        val = isObject ? JSON.stringify(val) : val;
        localStorage.setItem(key, val);
    }

    /**
     * Fetches value of the given key from the browser's Local Storage
     * @param key The key against which the value is stored.
     * @returns any if an Object was stored, an Object is returned. Otherwise, string.
     */
    getLocal(key) {
        let res;
        // maybe it is json?
        try {
            res = JSON.parse(localStorage.getItem(key));
        } catch (err) {
            res = localStorage.getItem(key);
        }

        return res;
    }

    /**
     * Removes the key/value pair from the browser's Local Storage.
     * @param key The key o the pair to be removed.
     */
    removeLocal(key) {
        localStorage.removeItem(key);
    }

    /**
     * Saves value to the browser's Session Storage
     * @param key The key against which the value will be stored.
     * @param val The value/object to be stored
     * @param isObject Objects are stored in JSON, set to false if string.
     */
    saveSessionProperty(key, val, isObject = true) {
        val = isObject ? JSON.stringify(val) : val;
        sessionStorage.setItem(key, val);
    }

    /**
     * Fetches value of the given key from the browser's Session Storage
     * @param key The key against which the value is stored.
     * @returns any if an Object was stored, an Object is returned. Otherwise, string.
     */
    getSessionProperty(key) {
        let res;
        // maybe it is json?
        try {
            res = JSON.parse(sessionStorage.getItem(key));
        } catch (err) {
            res = sessionStorage.getItem(key);
        }

        return res;
    }

    /**
     * Removes the key/value pair from the browser's Session Storage.
     * @param key The key o the pair to be removed.
     */
    removeSessionProperty(key) {
        sessionStorage.removeItem(key);
    }

    // download all file types
    download(data, fileName, fileType) {
        // alert(navigator.userAgent + 'z' + _.includes(navigator.userAgent, 'Safari') + 'zz'+ !_.includes(navigator.userAgent, 'Chrome'));
        // default file name
        fileName = fileName || "unknown";
        // the default file type is text
        fileType = fileType || "text/plain";
        // add UTF-8 BOM to data so it is parsed in UTF-8
        var blob = new Blob(['\uFEFF' + data], { type: fileType });
        var url = URL || window.webkitURL || window;
        var objectUrl = url.createObjectURL(blob);

        // window.open(objectUrl);
        // handle on IE
        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, fileName);
        } else {
            // handle on the normal browsers
            let hiddenElement = document.createElement("a");
            // res =  "1;2;3;4;5\n 1;2;3;4;5";
            // hiddenElement.href = 'data:attachment/csv,' + encodeURI(res);
            hiddenElement.href = objectUrl;
            hiddenElement.target = "_blank";
            hiddenElement.download = fileName;

            // use different download method for ff
            if (navigator.userAgent.search("Firefox") > -1) {
                // window.location.href = hiddenElement;
                document.body.appendChild(hiddenElement);
                hiddenElement.click();
                document.body.removeChild(hiddenElement);
            } else if (_.includes(navigator.userAgent, 'Safari') && !_.includes(navigator.userAgent, 'Chrome')) {
                var opened = window.open(objectUrl, "_blank");
                if (!opened) {
                    // Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
                    window.location.href = objectUrl;
                }
            } else {
                hiddenElement.click();
            }
        }
    }
}

const core = new Core();

export default core;
